type CacheEntry<T> = {
    data: T;
    expiry: number; // Timestamp in milliseconds
  };
  
  class CacheUtility {
    private static buildKey(key: string): string {
      return `CACHE_${key}`;
    }
  
    // Set an item in sessionStorage
    set<T>(key: string, data: T, ttl: number = 300000): void {
      const expiry = Date.now() + ttl * 1000; // Convert TTL to milliseconds
      const cacheEntry: CacheEntry<T> = { data, expiry };
      sessionStorage.setItem(CacheUtility.buildKey(key), JSON.stringify(cacheEntry));
    }
  
    // Get an item from sessionStorage
    get<T>(key: string): T | null {
      const cacheKey = CacheUtility.buildKey(key);
      const item = sessionStorage.getItem(cacheKey);
  
      if (!item) {
        return null;
      }
  
      const cacheEntry: CacheEntry<T> = JSON.parse(item);
  
      // Check if the cache has expired
      if (cacheEntry.expiry > Date.now()) {
        return cacheEntry as T;
      }
  
      // If expired, remove the item and return null
      sessionStorage.removeItem(cacheKey);
      return null;
    }
  
    // Remove a specific key
    remove(key: string): void {
      sessionStorage.removeItem(CacheUtility.buildKey(key));
    }
  
    // Clear the entire cache
    clear(): void {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith("CACHE_")) {
          sessionStorage.removeItem(key);
        }
      });
    }
  }
  
  export const cacheUtility = new CacheUtility();
  